import { ConvertStringToHtmlId } from '../../../../../../libs/ts/ConvertStringToHtmlId';
import { Meters } from '../../../../APIDocs/apiTypes';
import { Card } from '../../components/Card';
import { Title } from '@portal_components/components/Title';
import { Typography } from '../../components/Typography';
import { MeterDetailsLoading } from '../loadingElements/MeterDetailLoading';

export interface props {
  meters: Meters | undefined;
  dataErrorOccurred: boolean;
  className?: string;
  loading: boolean;
  error: { msg?: string | undefined } | null;
}

export const MeterDetail = (props: props) => {
  const noMetersExist = (props.meters == undefined || props.meters?.length == 0) && props.dataErrorOccurred == false;

  return (
    <div className="bg-white shadow rounded py-4">
      {props.loading ? (
        <MeterDetailsLoading />
      ) : props.error ? (
        <Typography content="Unable to load meter details." />
      ) : (
        <div className={`inline-block px-2`}>
          <Title className="mb-4" text="Meters:" />
          <div className="overflow-y-scroll h-screen pr-2">
            {noMetersExist ? (
              <Typography content="There are no meter details available to view. Once a meter has been installed, it will be displayed here" />
            ) : (
              props.meters?.map((meter, index) => {
                if (meter == undefined || meter.Serial == undefined) {
                  return <span key={index}></span>;
                } else {
                  const cardContent = `Supplier: ${meter.Supplier != null ? meter.Supplier : 'Unknown'}`;
                  const title = `Serial Number: ${meter.Serial}`;
                  return (
                    <Card key={index} className="p-5 mb-4" render={true} identifier="meterDetail">
                      <h2 className="font-bold pb-2">{title}</h2>
                      <span id={`jbp-card-content-${ConvertStringToHtmlId(title)}`} className="whitespace-pre-line text-soft-elevation-0">
                        {cardContent}
                      </span>
                    </Card>
                  );
                }
              })
            )}
          </div>
        </div>
      )}
    </div>
  );
};
